export default __webpack_public_path__ + "static/media/warning.0fc19d82.svg";